module.exports = __webpack_public_path__ + "img/OV.fbaa7b84.svg";